if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) {
        console.warn('[product-form] no <form> found; add to cart not bound', this);
        return;
      }
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      else console.warn('[product-form] no [name=id] input in form', this);
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // Optional debug: log any attempts to disable the submit button
      try {
        if (this.submitButton && window.MutationObserver) {
          const dbg = () => {
            if (localStorage.getItem('debugPDPDisable') === '1') {
              console.warn('[PDP Debug] submitButton mutated', {
                disabled: this.submitButton.disabled,
                aria: this.submitButton.getAttribute('aria-disabled'),
                class: this.submitButton.className
              });
            }
          };
          const mo = new MutationObserver(dbg);
          mo.observe(this.submitButton, { attributes: true, attributeFilter: ['disabled','aria-disabled','class'] });
        }
      } catch(e) {}
    
      // Phase 1c-iii fix: Only treat <cart-notification>/<cart-drawer> as the cart
      // UI if their custom-element class is actually registered. With Kaching as
      // the live cart drawer, both Dawn elements may be present in the DOM but
      // have no class registered (cart-notification.js was deleted; cart-drawer
      // is gated off). Calling .getSectionsToRender() on a vanilla element
      // throws and leaves the spinner stuck. Fall through to null → the success
      // path below dispatches cart:add:success which Kaching's app embed handles.
      this.cart = null;
      const dawnCartNotification = document.querySelector('cart-notification');
      const dawnCartDrawer = document.querySelector('cart-drawer');
      if (dawnCartNotification && typeof dawnCartNotification.getSectionsToRender === 'function') {
        this.cart = dawnCartNotification;
      } else if (dawnCartDrawer && typeof dawnCartDrawer.getSectionsToRender === 'function') {
        this.cart = dawnCartDrawer;
      }
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.cart && this.cart.tagName === 'CART-DRAWER') this.submitButton.setAttribute('aria-haspopup', 'dialog');
      // Keep Add to Cart + hidden id in sync with variant changes
      document.addEventListener('variant:changed', (ev) => {
        try {
          const d = ev.detail || {};
          if (!d.variant) return;
          // Scope: same section
          const section = this.closest('section');
          if (d.sectionId && section && !section.id.includes(d.sectionId)) return;
          // Normalize id input & quantity
          const idInput = this.form && this.form.querySelector('[name="id"]');
          if (idInput) { idInput.disabled = false; idInput.removeAttribute('disabled'); idInput.value = d.variant.id; }
          const qtyInput = this.form && this.form.querySelector('input[name="quantity"]');
          if (qtyInput && (parseInt(qtyInput.value || '1', 10) < 1)) qtyInput.value = '1';
          // Enable/disable submit strictly by availability
          if (this.submitButton) {
            if (d.variant.available) {
              this.submitButton.removeAttribute('disabled');
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('disabled','is-disabled');
            } else {
              this.submitButton.setAttribute('disabled','disabled');
              this.submitButton.setAttribute('aria-disabled','true');
              this.submitButton.classList.add('disabled','is-disabled');
            }
          }
        } catch(e) {}
      }, { passive: true });
    
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
    this.error = false;
this.submitButton && this.submitButton.removeAttribute('aria-disabled');
if (this.submitButton.disabled) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinnerOn = this.querySelector('.loading-overlay__spinner');
      if (spinnerOn) spinnerOn.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // Ensure correct quantity from PDP qty input, even if it's outside the <form> via [form] attribute.
      try {
        const formId = this.form && this.form.id;
        let qtyEl = null;
        if (formId) {
          qtyEl = document.querySelector(`input[name="quantity"][form="${formId}"]`);
        }
        if (!qtyEl) {
          // Fallback: look inside the form
          qtyEl = this.form.querySelector('input[name="quantity"]');
        }
        if (qtyEl) {
          // Respect disabled state: if disabled, do not include (Shopify defaults to 1); otherwise set explicitly.
          if (!qtyEl.disabled) {
            const qv = parseInt(qtyEl.value || '1', 10);
            const min = parseInt(qtyEl.getAttribute('min') || '1', 10) || 1;
            let max = qtyEl.getAttribute('max');
            max = (max !== null && max !== '') ? parseInt(max, 10) : null;
            let safeQ = Number.isFinite(qv) ? qv : 1;
            if (safeQ < min) safeQ = min;
            if (max !== null && Number.isFinite(max) && safeQ > max) safeQ = max;
            // Force the quantity into FormData so Shopify receives the intended value
            formData.set('quantity', String(safeQ));

      // Hard fallback: if 'quantity' is still missing from FormData, try common PDP selectors
      try {
        if (!formData.has('quantity')) {
          const cand = document.querySelector('.pdp-suite input[name="quantity"]')
                    || document.querySelector('#QuantityProxy-' + (this.form?.id?.replace('product-form-','') || ''))
                    || document.querySelector('input.quantity__input[name="quantity"]');
          if (cand && !cand.disabled) {
            formData.set('quantity', String(Math.max(1, parseInt(cand.value || '1', 10) || 1)));
          }
        }
      } catch(e) {}

          }
        }
      } catch(e) {
        if (window && window.console && localStorage.getItem('debugPDPQty') === '1') {
          console.warn('[PDP Qty Fix] Could not enforce quantity', e);
        }
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            const btnLabel = this.submitButton.querySelector('span');
            if (btnLabel) btnLabel.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            // Phase 1c-iii: Kaching is the live cart UI — no Dawn cart element
            // is registered. Dispatch cart:add:success which Kaching's app embed
            // listens for to open its drawer. Do NOT redirect to /cart (would
            // be jarring UX given Kaching is supposed to handle this). Falling
            // through to the .finally() block resets the button state.
            document.dispatchEvent(new CustomEvent('cart:add:success', {
              bubbles: true,
              detail: { source: 'pdp', message: 'Item added to cart' }
            }));
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response)
;document.dispatchEvent(new CustomEvent('cart:add:success',{bubbles:true,detail:{source:'pdp',message:'Item added to cart'}}));
window.__blockDrawerAutoOpenUntil = Date.now() + 3000;
 });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response)
;document.dispatchEvent(new CustomEvent('cart:add:success',{bubbles:true,detail:{source:'pdp',message:'Item added to cart'}}));
window.__blockDrawerAutoOpenUntil = Date.now() + 3000;
;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          const spinnerOff = this.querySelector('.loading-overlay__spinner');
          if (spinnerOff) spinnerOff.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        const variantGroup = this.closest('.variants-group');
        if(variantGroup){
          const variants = variantGroup.querySelectorAll('product-form');
          let total = 0;
          variants.forEach(function(el){
            total += el.offsetHeight + 10;
          });
          variantGroup.style.height = `${total}px`;
        }
        
      }
    }
  });
}
